import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import PrimaryButtonCard from '../../components/PrimaryButtonCard/PrimaryButtonCard';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { setInputType } from '../../redux/actions/result.action';
import { loadContentForPage, pushAndStop } from '../../redux/actions/text.action';
import './SelectAvatar.scss';

//icon
import thumpUpIcon from '../../assets/thump_up.png';

//avatars
import tobiIcon from '../../assets/lebenshilfe_avatar_1a.svg';
import magdalenaIcon from '../../assets/lebenshilfe_avatar_2a.svg';
import apeIcon from '../../assets/lebenshilfe_avatar_3a.svg';
import catIcon from '../../assets/lebenshilfe_avatar_4a.svg';


//text
import text from '../../assets/text/text.json';

import PrimaryButtonIcon from '../../components/PrimaryButtonIcon/PrimaryButtonIcon';
import { setAvatar } from '../../redux/actions/avatar.action';


const avatars = [
    {
        "name": "Tobi",
        "img": tobiIcon,
        "voice": "de-AT-Michael",
        "gender": "male"
    },
    {
        "name": "Magdalena",
        "img": magdalenaIcon,
        "voice": "de-DE-KatjaNeural",
        "gender": "female"
    },
    {
        "name": "KingKong",
        "img": apeIcon,
        "voice": "de-DE-Hedda",
        "gender": "female"
    },
    {
        "name": "Carlos",
        "img": catIcon,
        "voice": "de-DE-Stefan-Apollo",
        "gender": "male"
    },
]
/**
 * Select the input. Available inputs are text, speech and photo
 */
class SelectAvatar extends Component<{ navigateTo: any, setInput: any, setCurrentpage: any, setAvatar: any }, {}> {

    renderAvatars() {
        return avatars.map((item: any, key: any) => {
            return (<div className="avatar" onClick={() => {
                localStorage.setItem('lhgraz_avatar', JSON.stringify(item));
                this.props.setAvatar(JSON.stringify(item));
                this.props.navigateTo('/home');
            }}>
                <img src={item.img} className="avatar-img" />
            </div>)
        })
    }

    renderBody() {
        return (
            <div className="select-avatar-container">
                <div className="select-avatars">
                    {this.renderAvatars()}
                </div>
                <PrimaryButtonIcon icon={thumpUpIcon} text={text.selectAvatar.nextBtn} style={{ justifyContent: 'flex-start', paddingLeft: 20 }} action={() => {
                    localStorage.setItem('lhgraz_avatar', JSON.stringify(avatars[0]));
                    this.props.navigateTo('/home')
                }} />
            </div>
        )
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="select-avatar">
                <PageTemplate assistantLine1={text.selectAvatar.Assistant.line1} assistantLine2={text.selectAvatar.Assistant.line2} body={this.renderBody()} page="eingabeMethode" text={['']} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setInput(type: string) {
            dispatch(setInputType(type));
        },
        navigateTo(path: string) {
            dispatch(pushAndStop(path));
        },
        setAvatar(avatar: any) {
            dispatch(setAvatar(avatar));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectAvatar);